"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialog = exports.useInlineDialog = void 0;
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const HelperUtils_1 = require("utils/HelperUtils");
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const SVGIcon_1 = __importDefault(require("src/components/shared/SVGIcon"));
const SearchBar_1 = __importDefault(require("src/components/shared/SearchBar"));
const DialogContext = react_1.default.createContext(null);
DialogContext.displayName = 'DialogContext';
const useInlineDialog = () => react_1.default.useContext(DialogContext);
exports.useInlineDialog = useInlineDialog;
function InlineDialog({ type, header, search, selectedData, children, customClass = '', isBlock }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    let searchOption = null;
    if ((0, isFunction_1.default)(search)) {
        searchOption = {
            placeholder: (0, HelperUtils_1.getObjectiveLocale)('Search'),
            onSearch: search
        };
    }
    if (typeof search == 'object') {
        searchOption = {
            placeholder: (0, HelperUtils_1.getObjectiveLocale)(search['placeholder']),
            onSearch: search['onSearch']
        };
    }
    const ref = react_1.default.useRef(null);
    (0, useClickOutside_1.default)(ref, () => {
        setOpen && setOpen(false);
    });
    const contextValue = {
        open,
        header,
        type,
        setOpen: () => setOpen(!open),
        searchOption,
        selectedData,
        ref
    };
    return (react_1.default.createElement(DialogContext.Provider, { value: contextValue },
        react_1.default.createElement("div", { ref: ref, className: `${customClass ? customClass : ''} relative ${isBlock ? 'block' : 'inline-block'} text-left` }, children)));
}
const useDialog = () => react_1.default.useContext(DialogContext);
exports.useDialog = useDialog;
function MenuItems({ children, position, vPosition = 'bottom', options, style, isParent = true, onScroll, onOpenDialog, isLoading, customSelectedComponent, customClass = '', useTrigger = true, dataCy, emptyState, onCloseDialog, maxHeightWrapper = 256 }) {
    // get data from props if context not found or undefined
    const context = (0, exports.useDialog)();
    const { type, selectedData, header, searchOption, open } = context || {};
    const localRef = react_1.default.useRef(null);
    const firstRender = (0, react_1.useRef)(true);
    // empty state props
    const _a = emptyState || {}, { show: showEmptyState } = _a, emptyStateProps = __rest(_a, ["show"]);
    const MenuCN = ({ position = 'left', isParent, customClass }) => {
        return (0, classnames_template_literals_1.default)(`
      shadow-raised
      rounded-md
      items-center
      absolute
      z-10
      bg-n-000
      origin-top-right
      mt-[2px]
      py-[12px]
      ${customClass && customClass}
      ${vPosition === 'top' && 'top-0 -translate-y-full'}
      ${vPosition === 'bottom' && 'bottom-0 translate-y-full'}
      ${position === 'left' && 'left-0'}
      ${position === 'right' && 'right-0'}
      ${position === 'middle' && 'left-0 -translate-x-1/2'}
      ${!isParent && 'absolute top-0 translate-x-full'}
      `);
    };
    (0, react_1.useEffect)(() => {
        open && onOpenDialog && onOpenDialog();
        if (firstRender.current) {
            firstRender.current = false;
        }
        else {
            !open && onCloseDialog && onCloseDialog();
        }
    }, [open]);
    if (useTrigger && !open)
        return null;
    return (react_1.default.createElement("div", { className: MenuCN({ position, vPosition, isParent, customClass }), style: style, "data-cy": dataCy, ref: localRef },
        header && (react_1.default.createElement("p", { className: "mb-[16px] px-[16px] typography-h100 text-n-600" }, (0, HelperUtils_1.getObjectiveLocale)(header))),
        customSelectedComponent
            ? customSelectedComponent
            : selectedData &&
                selectedData.length > 0 && (react_1.default.createElement(SelectedItem, { selectedData: selectedData })),
        searchOption && (react_1.default.createElement("div", { className: "px-[16px] mb-[16px]" },
            react_1.default.createElement(SearchBar_1.default, { fullWidth: true, placeholder: searchOption === null || searchOption === void 0 ? void 0 : searchOption.placeholder, onChange: searchOption === null || searchOption === void 0 ? void 0 : searchOption.onSearch }))),
        showEmptyState && react_1.default.createElement(ListEmptyState_1.default, Object.assign({}, emptyStateProps)),
        react_1.default.createElement("div", { className: "py-[1px] overflow-hidden hover:overflow-overlay hover:overflow-auto", onScroll: onScroll, style: { maxHeight: `${maxHeightWrapper}px` } },
            isLoading && react_1.default.createElement(LoadingComponent_1.default, null),
            !isLoading && (react_1.default.createElement(react_1.default.Fragment, null, options
                ? options === null || options === void 0 ? void 0 : options.map((_a, index) => {
                    var props = __rest(_a, []);
                    return (react_1.default.createElement(MenuItem, Object.assign({}, props, { type: type, key: index })));
                })
                : children)))));
}
function SelectedItem({ selectedData, children }) {
    const IconWrapper = () => {
        return (0, classnames_template_literals_1.default)(`
      absolute
      top-0
      right-0
      w-[16px] h-[16px]
      rounded-full
      bg-n-700
    `);
    };
    return (react_1.default.createElement("div", { className: "px-[16px] py-[12px] h-[48px] mb-[4px]", "data-cy": "selected-item-wrapper" },
        react_1.default.createElement("div", { className: "flex pb-[8px] w-full overflow-hidden hover:overflow-overlay hover:overflow-auto" },
            !children &&
                selectedData.map(({ id, value, image, onRemove }, index) => {
                    return (react_1.default.createElement("div", { className: "relative mr-[12px]", key: index },
                        react_1.default.createElement(Avatar_1.default, { src: image, name: value, customClass: "mr-[8px]", size: 24 }),
                        react_1.default.createElement("div", { className: IconWrapper(), onClick: () => onRemove(id), "data-cy": "inline-dialog-remove-user" },
                            react_1.default.createElement(SVGIcon_1.default, { size: 16, iconName: "icon-clear", fillColor: "var(--n-000)" }))));
                }),
            children && children)));
}
function MenuItem({ id, children, selected, image, avatarName, onClick, customClass = '', text, subText, rightIcon, dataCy, dataCyTitle }) {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [isEllipsis, setIsEllipsis] = (0, react_1.useState)(false);
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const setPortal = (e) => {
        if (isEllipsis) {
            setIsTooltipShown(true);
            setPortalData({
                name: subText,
                left: e.currentTarget.getBoundingClientRect().x + 'px',
                top: e.currentTarget.getBoundingClientRect().top - 30 + 'px'
            });
        }
    };
    const MenuItemCN = (customClass) => {
        return (0, classnames_template_literals_1.default)(`
    flex
    px-[16px]
    py-[8px]
    min-w-[256px]
    items-center
    justify-between
    hover:bg-base-30016
    cursor-pointer
    ${selected && 'bg-base-30024'}
    ${customClass}
  `);
    };
    const { setOpen, type } = (0, exports.useDialog)() || {};
    let rightIconOption = {
        color: '',
        icon: ''
    };
    if (typeof rightIcon == 'object') {
        rightIconOption = {
            color: rightIcon['color'],
            icon: rightIcon['icon']
        };
    }
    else {
        rightIconOption = {
            color: 'var(--n-400)',
            icon: rightIcon || ''
        };
    }
    const _onClick = (e) => {
        onClick && onClick(e);
        // if type is not multiple then close the dialog
        type !== 'multiple' && setOpen && setOpen();
    };
    return (react_1.default.createElement("li", { onClick: _onClick, className: MenuItemCN(customClass), "data-cy": dataCy },
        react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: "shared-tooltip" }),
        react_1.default.createElement("div", { className: "flex items-center w-full justify-between", "data-cy": "inline-dialog-item" },
            !children && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "flex items-center w-full" },
                    type == 'multiple' && (react_1.default.createElement(Checkbox_1.default, { name: String(id), id: String(id), checked: !!selected, customContainerClass: "mr-[8px]", dataCy: "inline-dialog-checkbox", onClick: _onClick })),
                    (image || avatarName) && (react_1.default.createElement(Avatar_1.default, { src: image, name: avatarName, customClass: "mr-[8px]", size: 32 })),
                    react_1.default.createElement("div", { className: "flex flex-col grow overflow-hidden" },
                        react_1.default.createElement("span", { className: "typography-h400 block", "data-cy": dataCyTitle }, text),
                        react_1.default.createElement("span", { ref: (ref) => ref && setIsEllipsis((ref === null || ref === void 0 ? void 0 : ref.offsetWidth) < (ref === null || ref === void 0 ? void 0 : ref.scrollWidth)), onMouseOver: setPortal, onMouseOut: () => setIsTooltipShown(false), className: "typography-secondary truncate" }, subText))),
                rightIcon && (react_1.default.createElement(SVGIcon_1.default, { size: 24, customClass: "text-n-600", iconName: rightIconOption.icon, fillColor: rightIconOption.color })))),
            children && children)));
}
function Trigger({ children, beforeTrigger, disabled, dataCy, customClass }) {
    const triggerCN = (0, classnames_template_literals_1.default)(`
    relative
    ${!disabled ? 'cursor-pointer' : 'cursor-not-allowed'}
    ${customClass}
  `);
    const { setOpen } = (0, exports.useDialog)() || {};
    const onClick = (e) => {
        e.stopPropagation();
        if (!disabled) {
            beforeTrigger
                ? beforeTrigger(() => setOpen && setOpen(), e)
                : setOpen && setOpen();
        }
    };
    return (react_1.default.createElement("div", { className: triggerCN, onClick: onClick, "data-cy": dataCy }, children));
}
InlineDialog.displayName = 'InlineDialog';
InlineDialog.Trigger = Trigger;
InlineDialog.MenuItem = MenuItem;
InlineDialog.MenuItems = MenuItems;
InlineDialog.SelectedItem = SelectedItem;
exports.default = InlineDialog;
